import './EditorialStyles.css'
import { ReactTyped as Typed } from 'react-typed';
import { HiChevronDoubleDown } from "react-icons/hi";
import { Link as LinkScroll } from 'react-scroll';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import { useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const EditorialContent = (props) => {
  const { t } = useTranslation('common');
  const titleRef = useRef();

  const onLoad = () => {
    gsap.timeline().fromTo(".letter",
      {
        x: -100,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
        stagger: 0.33,
        delay: 0.3,
      }).to('.letter',
        {
          margin: "0 1vw",
          delay: 0.8,
          duration: 0.5
        }).to(".letter", {
          margin: "0",
          delay: 0.8,
          duration: 0.5
        })

  }

  useEffect(() => {
    onLoad();

  }, [])

  return (
    <div className='editorial'>

      <div className='editorial-home'>
        <div className='editorial-title'>
          <h1 id='title' ref={titleRef}>
            <span className='letter'>é</span>
            <span className='letter'>D</span>
            <span className='letter'>I</span>
            <span className='letter'>T</span>
            <span className='letter'>O</span>
            <span className='letter'>R</span>
            <span className='letter'>I</span>
            <span className='letter'>A</span>
            <span className='letter'>L</span>
          </h1>
          <h3> {t('editorial.le_toss')}
            <span> </span>
            <span className='gradient'>
              <Typed
                strings={[

                  `${t('editorial.v1')}`,
                  `${t('editorial.v2')}`,
                  `${t('editorial.v3')}`,
                  `${t('editorial.v4')}`,

                ]}
                typeSpeed={80}
                backSpeed={50}
                loop />
            </span>
          </h3>

        </div>


        <span className='chevrondouble'><LinkScroll to='editorial-content' smooth={true} offset={-100} duration={1000}><HiChevronDoubleDown size={40} /></LinkScroll></span>
        <div className='vague'>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#f5f4f4" fillOpacity="1" d="M0,288L60,288C120,288,240,288,360,266.7C480,245,600,203,720,208C840,213,960,267,1080,288C1200,309,1320,299,1380,293.3L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
        </div>

      </div>
      <div className='editorial-content' id="editorial-content">
        <h3> {t('editorial.idf_terre')} </h3>

        <p>
          {t('editorial.para1')}

          <br />
          <br />

          {t('editorial.para2')}

          <br />
          <br />

          {t('editorial.para3')}
          <br />
          <br />

          {t('editorial.para4')}

          <br />
          <br />

          {t('editorial.para5')}

          <br />
          <br />

          {t('editorial.para6')}

          <br />
          <br />

          {t('editorial.para7')}
        </p>
      </div>
      <div className='editorial_signature'>
        <div className='semi-circle'>
        </div>
        <div className='editorial-name'>
          <div>
            <h3> Valérie PECRESSE</h3>
            <p>   {t('editorial.presidente')}</p>
          </div>
          <br />
          <br />
          <div>
            <h3> Patrick KARAM</h3>
            <p>  {t('editorial.vice-président')}</p>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div className='semi-circle-2'>
          </div>



        </div>

      </div>
    </div>
  )
}

export default EditorialContent
